import {Group} from "../../types";
import {axiosInstance} from "../../utils";

export const fetchGroups = async (): Promise<Group[]> => {
  const response = await axiosInstance.get<Group[]>(
    "/groups",
  );
  return response.data;
};